import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Box, Grid, Button, Chip, InputBase, IconButton, Divider, TextField, TablePagination } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Skeleton from '@mui/material/Skeleton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import SearchIcon from '@mui/icons-material/Search';
import CachedIcon from '@mui/icons-material/Cached';


export const UsersComp = (props) => {


    return (
        <Box>
            <Box>
                <Grid container>

                    <Grid md={4}>
                        <Box>
                            <Paper
                                component="form"
                                sx={{ p: '2px 4px', height: 40, display: 'flex', alignItems: 'center', width: '100%' }}
                            >
                                <InputBase
                                    sx={{ ml: 1, flex: 1 }}
                                    placeholder="Search By Name, Number..."
                                    inputProps={{ 'aria-label': '' }}
                                    value={props.mystate.searchObj.txtUserSearchName || ''}
                                    onChange={(e) => props.HandleInputs(e, 'txtUserSearchName')}
                                />
                                <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
                                    <SearchIcon onClick={() => props.SearchUserList('direct', '')} />
                                </IconButton>
                                <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                                <IconButton color="" sx={{ p: '10px' }} aria-label="directions">
                                    <CachedIcon onClick={() => props.SearchUserList('reload', '')} />
                                </IconButton>
                            </Paper>

                        </Box>
                    </Grid>

                     <Grid md={2}>
                        <Box pl={1} pr={1}>
                            <FormControl fullWidth>
                                <TextField
                                    size='small'
                                    select
                                    value={props.mystate.searchObj.ddlSearchUserType || ''}
                                    label="User Type"
                                    onChange={(e) => props.HandleInputs(e, 'ddlSearchUserType')}
                                >
                                    {
                                        props.mystate.profileList.length > 0 ?
                                            props.mystate.profileList.map((item) =>
                                                <MenuItem value={item.profile_name}>{item.profile_name}</MenuItem>
                                            )
                                            :
                                            null
                                    }
                                </TextField>
                            </FormControl>
                        </Box>
                    </Grid>


                    

                    <Grid md={6} textAlign={'end'}>
                        <Box>
                            <Button className='grey-theme-btn' variant="outlined" startIcon={<AddIcon />} onClick={() => props.NavigateTo('user')}>
                                Add New User
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
            <Box style={{ marginTop: '20px' }}>
                {
                    props.mystate.getUsersList == false ?
                        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                            <TableContainer sx={{ maxHeight: 380 }}>
                                <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell
                                                key={'SrNo'}
                                                align={'left'}
                                                style={{ minWidth: 70 }}
                                                className='table-head-cell'
                                            >
                                                {'SrNo'}
                                            </TableCell>
                                            <TableCell
                                                key={'Contact Info'}
                                                align={'left'}
                                                style={{ minWidth: 170 }}
                                                className='table-head-cell'
                                            >
                                                {'Contact Info'}
                                            </TableCell>
                                            <TableCell
                                                key={'Reporting To'}
                                                align={'left'}
                                                style={{ minWidth: 170 }}
                                                className='table-head-cell'
                                            >
                                                {'Reporting To'}
                                            </TableCell>
                                            <TableCell
                                                key={'Profile'}
                                                align={'left'}
                                                style={{ minWidth: 100 }}
                                                className='table-head-cell'
                                            >
                                                {'Profile'}
                                            </TableCell>

                                            <TableCell
                                                key={'Status'}
                                                align={'left'}
                                                style={{ minWidth: 100 }}
                                                className='table-head-cell'
                                            >
                                                {'Status'}
                                            </TableCell>
                                            <TableCell
                                                key={'Added On/By'}
                                                align={'left'}
                                                style={{ minWidth: 170 }}
                                                className='table-head-cell'
                                            >
                                                {'Added On'}
                                            </TableCell>
                                            <TableCell
                                                key={'Last Login'}
                                                align={'left'}
                                                style={{ minWidth: 170 }}
                                                className='table-head-cell'
                                            >
                                                {'Last Login'}
                                            </TableCell>
                                            <TableCell
                                                key={'Details'}
                                                align={'left'}
                                                style={{ minWidth: 100 }}
                                                className='table-head-cell'
                                            >
                                                {''}
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {props.mystate.usersList != undefined && props.mystate.usersList.length > 0 ?
                                            props.mystate.usersList.map((item, i) => (
                                                <TableRow hover role="checkbox" tabIndex={-1} key={item._id}>
                                                    <TableCell key={i + 1} align={'left'}>
                                                        {i + 1}
                                                    </TableCell>
                                                    <TableCell key={item.user_name + i} align={'left'}>
                                                        {item.user_name} <br></br> {item.user_mobile}
                                                    </TableCell>
                                                    <TableCell key={item.user_reporting_name + i} align={'left'}>
                                                        {item.user_reporting_name}
                                                    </TableCell>
                                                    <TableCell key={item.user_profile_name + i} align={'left'}>
                                                        <Chip sx={{ backgroundColor: item.user_profile_name == 'IFA' ? '#e73100' : item.user_profile_name == 'Investor' ? '#07427e' : '#042740', color: '#fff' }} label={item.user_profile_name} />
                                                    </TableCell>
                                                    <TableCell key={item.user_status + i} align={'left'}>
                                                        <Chip sx={{ backgroundColor: item.user_status == 1 ? '#439f00' : '#e73100', color: '#fff' }} label={item.user_status == 1 ? 'Active' : 'In Active'} />
                                                    </TableCell>

                                                    <TableCell key={item.user_added_by + i} align={'left'}>
                                                        {item.user_added_by} <br></br> {item.user_added_on}
                                                    </TableCell>
                                                    <TableCell key={'last_login_' + i} align={'left'}>
                                                        {item.user_login_history !== undefined && item.user_login_history.length > 0 ? <span>{item.user_login_history[item.user_login_history.length - 1].last_login} < br></br> {<strong>{item.user_login_history[item.user_login_history.length - 1].last_login_platform}</strong>}</span> : 'NA'}
                                                    </TableCell>
                                                    <TableCell key={item.cust_added_on + i} align={'left'}>
                                                        <Button><EditIcon className='grey-theme-btn' onClick={() => props.GetUserDetails(item._id)}></EditIcon></Button>
                                                    </TableCell>

                                                </TableRow>
                                            ))
                                            : ''
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>

                             
                              <TablePagination
                                rowsPerPageOptions={[10, 50, 100, 200, 300]}
                                component="div"
                                count={props.mystate.totalRecords}
                                rowsPerPage={props.mystate.perSet}
                                // page={props.mystate.setNo == 1 ? 1 + '-' + props.mystate.perSet : props.mystate.perSet * (props.mystate.setNo - 1) + '-' + props.mystate.perSet * (props.mystate.setNo) }
                                page={props.mystate.setNo - 1}
                                onPageChange={(e) => props.HandleChangePage(e,props.mystate.setNo - 1)}
                                //onPageChange={handleChangePage}
                                onRowsPerPageChange={(e) => props.HandleChangeRowsPerPage(e)}
                            />

                        </Paper>
                        :

                        <Box>
                            <Skeleton height={75} />
                            <Skeleton animation="wave" variant="rectangular" height={250} />
                            <Skeleton height={75} />
                        </Box>
                }

            </Box>


            <Dialog
                open={props.mystate.alertBox}
                onClose={props.HandleCloseAlert}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Delete User"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {'Do you want to remove ' + props.mystate.userName + ' permanently'}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => props.HandleCloseAlert('No')}>Disagree</Button>
                    <Button onClick={() => props.HandleCloseAlert('Yes')} autoFocus>
                        Agree
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>


    );
}